import { useState } from 'react';
import { FormattedMessage, trans } from '@lingoda/i18n';
import { Collapse } from '@lingoda/ui';
import { InfoIcon } from '@lingoda/ui/icons/lingodaIcons';
import { BannerAlert } from './styled';

export const ForTheBestExperienceUseDesktopDeviceBanner = () => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <Collapse in={isOpen} onExited={() => setIsOpen(false)} unmountOnExit>
            <BannerAlert
                severity={'info'}
                title={trans(
                    'for-the-best-experience-use-desktop-device.title',
                    {},
                    'classroom-common+intl-icu',
                )}
                variant="outlined"
                onClose={() => setIsOpen(false)}
                icon={<InfoIcon size={24} />}
            >
                <FormattedMessage
                    message={trans(
                        'for-the-best-experience-use-desktop-device.body',
                        {},
                        'classroom-common+intl-icu',
                    )}
                />
            </BannerAlert>
        </Collapse>
    );
};
